import { useNavigate } from "react-router-dom";
import BottomNavbar from "@/components/bottom-navbar";

export default function ComingSoon() {
  const navigate = useNavigate();

  return (
    <div className="h-screen flex flex-col items-center justify-center bg-white">
      <div className="text-center px-4">
        <svg
          className="w-16 h-16 mx-auto mb-4 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <h2 className="text-2xl font-bold text-gray-700 mb-2">Coming Soon</h2>
        <p className="text-gray-500 mb-4">
          This feature is currently under development.
        </p>
        <button
          onClick={() => navigate(-1)}
          className="text-pink-500 hover:text-pink-600 font-semibold"
        >
          Go Back
        </button>
      </div>
      <BottomNavbar />
    </div>
  );
}
